import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import {MsalService} from "@azure/msal-angular";
import { Cliente } from '../../../models/Cliente';
import {Campas} from "../../../models/Campas";

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class AgentsService
{
  private hostPeticionClientes:string = environment.rlsWSBase;
  constructor(private http: HttpClient,private msalService:MsalService){}
  public getEmailAgents(token:string,agent:string):Promise<any[]>
  {
    let url:string = this.hostPeticionClientes + "/Agents/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
    {
      parameters:
      [
        [
          {
            campo:"agent",
            operacion:"=",
            valor:agent.toString()
          }
        ]
      ],
      select:["email"]
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(response)
        {
          resolve(response);
        },
        error(err)
        {
          reject(err);
        }
      });
    });
  }
  public getEmailCom(token:string,agent:string,taller:string):Promise<any[]>
  {
    let url:string = this.hostPeticionClientes + "/Comerciales/emailsCom/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
      {
        agente: agent.toString(),
        taller: taller.toString()
      };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(response)
          {
            resolve(response);
          },
          error(err)
          {
            reject(err);
          }
        });
    });
  }

  public getEmailSubAgents(token:string,agent:string, agent_sub:string):Promise<any[]>
  {
    let url:string = this.hostPeticionClientes + "/AgentsSub/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
      {
        parameters:
          [
            [
              {
                campo:"agent",
                operacion:"=",
                valor:agent.toString()
              }
            ],
            [
              {
                campo:"agent_sub",
                operacion:"=",
                valor:agent_sub.toString()
              }
            ]
          ],
        select:["email"]
      };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(response)
          {
            resolve(response);
          },
          error(err)
          {
            reject(err);
          }
        });
    });
  }

  public getEmailComercial(token:string,taller:string):Promise<any[]>
  {
    let url:string = this.hostPeticionClientes + "/Comerciales/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
      {
        parameters:
          [
            [
              {
                campo:"taller",
                operacion:"=",
                valor:taller.toString()
              }
            ]
          ],
        select:["emailcial"]
      };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(response)
          {
            resolve(response);
          },
          error(err)
          {
            reject(err);
          }
        });
    });
  }

  public getEmailManager(token:string,taller:string):Promise<any[]>
  {
    let url:string = this.hostPeticionClientes + "/Comerciales/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
      {
        parameters:
          [
            [
              {
                campo:"taller",
                operacion:"=",
                valor:taller.toString()
              }
            ]
          ],
        select:["emailzona"]
      };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(response)
          {
            resolve(response);
          },
          error(err)
          {
            reject(err);
          }
        });
    });
  }

  public getCampas(token:string,taller:string, cliente: string, piloto: string){
    let url:string = this.hostPeticionClientes + "/Campa/getCampas"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
      {
        piloto: piloto,
        cliente: cliente,
        taller: taller
      };

    return new Promise<Campas[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(value:any)
          {
            resolve(value);
          },
          error(err)
          {
            reject(err);
          }
        });
    });
  }
}
